import { useTranslation } from "react-i18next";

export function useLanguageToggle() {
  const { i18n } = useTranslation();

  const language = i18n.language;
  const compactLabel = language === "en" ? "HR" : "EN";

  const toggleLanguage = () => {
    i18n.changeLanguage(language === "en" ? "hr" : "en");
  };

  return { language, compactLabel, toggleLanguage };
}
